import type { JobsOnboardingStep } from '../types';
import { JobsInquiryOnboardingV2State } from '@/types/graphql';

export default (): JobsOnboardingStep[] => {
  const onboardingV2Keys = Object.values(JobsInquiryOnboardingV2State);
  return onboardingV2Keys.map(step => ({
    route: step,
    key: step,
    title: step,
    component: step,
    nextStep: () => '',
  }));
};
